var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-home"},[_vm._l((_vm.$root.selected_components),function(selected_component,index){return [_c('section-' + selected_component.name,{key:'component' + selected_component.id,tag:"component",staticClass:"s-section",attrs:{"section":selected_component,"id":selected_component.name + '-' + selected_component.id},on:{"hook:mounted":function($event){return _vm.create_observer(selected_component)}}}),(
				index % 3 === 0 &&
					index != 0 &&
					index + 1 != _vm.$root.selected_components.length
			)?_c('span',{key:`ad_${index}`,staticClass:"d-block"},[_c('element-ad',{attrs:{"name":"signingday-repeated-1"}})],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }